import { useDispatch } from 'react-redux';
import './css/app.css'
import './css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal } from './component/modal/modal';

import { SquareX } from 'lucide-react';

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from './component/btn/btn';
import List from './component/list/list';
import { LoadingModal } from './component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn, SearchInput } from './component/search/search';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

function Help() {
    let dispatch = useDispatch()
    let navigate = useNavigate();
    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(20)
    const [loading, setLoading] = useState(true)

    const [createModal, setCreateModal] = useState(false)
    const [updateModal, setUpdateModal] = useState(false)

    const [message, setMessage] = useState("")
    const [adminData, setAdminData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [clickData, setClickData] = useState([])
    const [boardData, setBoardData] = useState([
        {
            id: 1,
            title: "게시판 제목 1",
            content: "게시판 내용 1",
            author: "작성자 1",
            date: "2025-01-20",
        },
        {
            id: 2,
            title: "게시판 제목 2",
            content: "게시판 내용 2",
            author: "작성자 2",
            date: "2025-01-19",
        },
        {
            id: 3,
            title: "게시판 제목 3",
            content: "게시판 내용 3",
            author: "작성자 3",
            date: "2025-01-18",
        },
        {
            id: 4,
            title: "게시판 제목 4",
            content: "게시판 내용 4",
            author: "작성자 4",
            date: "2025-01-17",
        },
        {
            id: 5,
            title: "게시판 제목 5",
            content: "게시판 내용 5",
            author: "작성자 5",
            date: "2025-01-16",
        },
        {
            id: 6,
            title: "게시판 제목 6",
            content: "게시판 내용 6",
            author: "작성자 6",
            date: "2025-01-15",
        },
        {
            id: 7,
            title: "게시판 제목 7",
            content: "게시판 내용 7",
            author: "작성자 7",
            date: "2025-01-14",
        },
        {
            id: 8,
            title: "게시판 제목 8",
            content: "게시판 내용 8",
            author: "작성자 8",
            date: "2025-01-13",
        },
    ]);

    const [reload, setReload] = useState(false)

    useEffect(() => {
        dispatch(change_Current_Location("고객센터"))
        dispatch(changeHeaderTitle({
            mainTitle: "고객센터"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    useEffect(() => {
        AdminData()
    }, [reload])

    const handleChange = (event) => {
        setMaxFirstPage(Number(event.target.value));
    };

    const AdminData = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/admin", {
            withCredentials: true,
            params: {

            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                setAdminData(tmp?.data?.admin ?? [])
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const tableHeaderData = [
        { "no": 1, "text": "No.", "width": "50px", "textAlign": "center" },
        { "no": 2, "text": "제목", "width": "150px", "textAlign": "center" },
        { "no": 3, "text": "내용", "width": "300px", "textAlign": "center" },
        { "no": 4, "text": "작성자", "width": "100px", "textAlign": "center" },
        { "no": 5, "text": "날짜", "width": "100px", "textAlign": "center" },
    ];

    useEffect(() => {
        let tableBodyData = [];
        if (boardData) {
            for (let i = 0; i < boardData.length; i++) {
                let data = boardData[i]

                tableBodyData.push([
                    { "no": 1, "text": i + 1, "width": "50px", "textAlign": "center" },
                    { "no": 2, "text": data.title, "width": "150px", "textAlign": "center" },
                    { "no": 3, "text": data.content, "width": "300px", "textAlign": "center" },
                    { "no": 4, "text": data.author, "width": "100px", "textAlign": "center" },
                    { "no": 5, "text": data.date, "width": "100px", "textAlign": "center" },
                ])
            }
            setCombineData(tableBodyData)
        }
    }, [boardData])

    // 한 페이지당 보여지는 개수만큼 배열 자르기
    let filter_tableBodyData = combineData.slice((page - 1) * maxFirstPage, (page) * maxFirstPage)

    const onDeleteData = async (e) => {
        if (window.confirm("관리자데이터를 삭제하시겠습니까?") === true) {
            await axios.post(process.env.REACT_APP_API + "/api/admin/delete", {
                adminId: e,
            }, {
                withCredentials: true,
            }).then((response) => {
                console.log(response.data)
                let tmp = response?.data
                if (tmp?.code < 2000) {
                    AdminData()
                }
                else {
                    setMessage({ msg: "관리자 삭제에 실패했습니다." })
                }
            }).catch(error => {
                console.error(error);
            });
        }
    }

    // 기간 포맷
    const inputRef = useRef(null);
    const pickerRef = useRef(null); // Litepicker 인스턴스를 저장할 ref

    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false, // 날짜 범위 선택
            format: 'YYYY-MM-DD', // 날짜 형식
            numberOfMonths: 2, // 두 달 표시
            numberOfColumns: 2, // 두 열로 나누어 표시
            showWeekNumbers: true, // 주 번호 표시
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                // 이벤트 리스너 등록
                picker.on('selected', (start, end) => {
                    setPreDate(start.format('YYYY-MM-DD'));
                    setNextDate(end.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            pickerRef.current?.destroy(); // 컴포넌트 언마운트 시 파괴
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().format('YYYY-MM-DD'))
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'))

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    // 날짜를 설정하는 함수
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    // 검색조건 포맷
    const select3 = ["제목", "내용", "작성자"]

    const [selectedValue2, setSelectedValue2] = useState("제목");

    const handleSelectChange2 = (event) => {
        const value = event.target.value;
        setSelectedValue2(value);
    };

    // 검색어 포맷
    const [selectedText4, setSelectText4] = useState("")

    const handleSelectTextChange4 = (event) => {
        const value = event.target.value;
        setSelectText4(value);
    };

    // 검색 버튼
    const submit = () => {
        setReload(e => !e)
    }

    // 더보기 버튼
    const [moreBtn, setMoreBtn] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 640) setMoreBtn(true)
            else setMoreBtn(false)
        };

        window.addEventListener('resize', handleResize);
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            {createModal ? <CreateInfo setModal={setCreateModal} setMessage={setMessage} setReload={setReload} /> : ""}
            <MessageModal message={message} />
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate 
                    type={"기간"} 
                    inputRef={inputRef} 
                    setDateRange={setDateRange} 
                    preDate={preDate}
                    nextDate={nextDate}
                    isDisabled={false} 
                    />
                    {<SearchSelectText type={"검색구분"} selectData={select3} handleSelectChange={handleSelectChange2} selectedValue={selectedValue2} handleSelectTextChange={handleSelectTextChange4} selectedText={selectedText4} btnText={"검색"} onClick={() => submit()} />}

                    <div className="button_wrap separate" style={{ marginTop: "0px" }}>
                        {/* <SearchCrteateBtn type={"게시글 등록"} onClick={() => setCreateModal(true)} /> */}
                    </div>
                </form>
                {/* <div className="more_wrap">
                    <button type="button" onClick={() => setMoreBtn(e => !e)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" icon-name="chevron-down" data-lucide="chevron-down" className="lucide lucide-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg><span>더보기</span>
                    </button>
                </div> */}
            </div>
            <div className="intro-y box intro-padding" >
                <div className="tabulator_sorting_wrap" style={{ flexDirection: "row" }}>
                    <CountAmountLeft tableBodyData={combineData} />
                    <div className='excel-disable'>
                        <CountSelect onChange={handleChange} maxFirstPage={maxFirstPage} />
                    </div>
                </div>
                <div className='div-flex-2'>
                    <div className='div-flex-2-1'>
                        <List tableHeaderData={tableHeaderData} tableBodyData={combineData} filter_tableBodyData={filter_tableBodyData} page={page} setPage={setPage} maxFirstPage={maxFirstPage} />
                    </div>
                    <div style={{ width: "400px" }}>
                        <Info
                            setMessage={setMessage}
                            clickData={clickData}
                            setReload={setReload}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

function CreateInfo({ setModal, setMessage, setReload }) {
    const [signupName, setSignupName] = useState('');
    const [signupEmail, setSignupEmail] = useState('');
    const [signupPw, setSignupPw] = useState('');
    const [signupId, setSignupId] = useState('');
    const [merchantGrade, setMerchantGrade] = useState('SUPER');

    const onSubmit = async () => {
        if (signupName != '' && signupEmail != '' && signupPw != '' && signupId != '') {
            await axios.post(process.env.REACT_APP_API + "/api/admin/regist", {
                name: signupName,
                email: signupEmail,
                password: signupPw,
                adminId: signupId,
                role: merchantGrade
            }, {
                withCredentials: true,
            }).then((response) => {
                let tmp = response?.data
                if (tmp?.code < 2000) {
                    setReload(e => !e)
                    setModal(false)
                }
                else {
                    setMessage({ msg: "관리자 등록에 실패했습니다." })
                }
            }).catch(error => {
                console.error(error);
            });
        }
        else {
            setMessage({ msg: "다시 입력해주세요." })
        }
    }

    return (
        <div id="admin-modal" className="modal show_modal" tabindex="-1">
            <input type="hidden" id="event_check" value="update" />
            <div className="modal-dialog">
                <div className="modal-content marginTop30 admin-modal-sty">
                    <div className="modal-header">
                        <h2 className="font-medium text-base mr-auto">관리자 정보</h2>
                        <div id="data_wrap">
                            <input type="hidden" id="m_code" />
                        </div>
                    </div>
                    <form id="modal-form" className="modal-body grid grid-cols-12 gap-4 gap-y-3">
                        <div className="col-span-12">
                            <label htmlFor="signup-id-merchant" className="form-label">관리자</label>
                            <input
                                id="signup-id-merchant"
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={signupName}
                                onChange={(e) => setSignupName(e.target.value)}
                            />
                        </div>

                        <div className="col-span-12">
                            <label htmlFor="signup-id" className="form-label">이메일</label>
                            <input
                                id="signup-id"
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={signupEmail}
                                onChange={(e) => setSignupEmail(e.target.value)}
                            />
                        </div>

                        <div className="col-span-12">
                            <label htmlFor="signup-phone" className="form-label">아이디</label>
                            <input
                                id="signup-phone"
                                type="text"
                                className="form-control"
                                placeholder=""
                                value={signupId}
                                onChange={(e) => setSignupId(e.target.value)}
                            />
                        </div>

                        <div className="col-span-12">
                            <label htmlFor="signup-pw" className="form-label">패스워드</label>
                            <input
                                id="signup-pw"
                                type="password"
                                autoComplete="off"
                                className="form-control"
                                placeholder=""
                                value={signupPw}
                                onChange={(e) => setSignupPw(e.target.value)}
                            />
                        </div>

                        <div id="merchant-list-wrap" className="col-span-12">
                            <label htmlFor="merchant-list" className="form-label">등급</label>
                            <div className="merchant-list-box">
                                <select
                                    id="merchant-list"
                                    className="form-select form-select-sm mt-2"
                                    value={merchantGrade}
                                    onChange={(e) => setMerchantGrade(e.target.value)}
                                >
                                    <option value="SUPER">SUPER</option>
                                    <option value="ADMIN">ADMIN</option>
                                    <option value="MANAGER">MANAGER</option>
                                </select>
                            </div>
                        </div>
                    </form>

                    <div className="modal-footer">
                        <button id="signup-btn" type="submit" className="btn btn-primary" onClick={() => onSubmit()}>등록</button>
                        <button type="button" data-tw-dismiss="modal" className="btn btn-outline-secondary mr-1 admin-modal-btn" onClick={() => setModal(false)}>닫기</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

function Info({ setModal }) {
    return (
        <div style={{ padding: "5px" }}>
            {/* <div id="modal" className="modal show_modal" tabindex="-1" > */}
            <div className="modal-dialog">
                <div className="marginTop30 modal_sty" style={{ fontSize: "12px", }}>
                    <div className="modal-header">
                        <h2 className="font-medium text-base mr-auto modal_title_sty">CSR 정보</h2>
                    </div>
                    <div>

                    </div>
                    <div className="modal-footer" >
                        <button type="button" className="btn btn-primary w-20 reg_btn">변경</button>
                        <button type="button" className="btn btn-primary delete_btn"
                            style={{ backgroundColor: 'darkred', marginLeft: '10px', border: 'none', width: "auto" }}>기기 삭제</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Help